// extracted by mini-css-extract-plugin
export default {"container":"WF-z","disabled":"XF-z","bgBlack":"YF-z","content":"ZF-z","countdown":"_F-z","topCaption":"aG-z","topHeading":"bG-z","heading":"cG-z","copy":"dG-z"};